/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import { formatRelativeTime } from './format-relative-time.js';

export interface ReportInfoProps {
  title: string;
  versionNumber: number;
  /** ISO timestamp. */
  lastModifiedAt: string;
  /** Display status (for example, 'Draft', 'In Review', 'Final'). */
  status: string;
  /** Optional status badge tone. */
  statusTone?: 'neutral' | 'info' | 'success' | 'warning';
}

export function ReportInfo({
  title,
  versionNumber,
  lastModifiedAt,
  status,
  statusTone = 'neutral',
}: ReportInfoProps) {
  const modifiedRelative = formatRelativeTime(lastModifiedAt);

  return (
    <section className="ecs-panel ecs-report-info">
      <h2 className="ecs-report-info__title" title={title}>
        {title}
      </h2>
      <div className="ecs-report-info__meta-row">
        <span className="ecs-report-info__version">V{versionNumber}</span>
        <span
          className={`ecs-report-info__badge ecs-report-info__badge--${statusTone}`}
          aria-label={`Status: ${status}`}
        >
          {status}
        </span>
      </div>
      <p className="ecs-report-info__modified">
        Last modified{' '}
        {modifiedRelative !== '' ? (
          <time dateTime={lastModifiedAt}>{modifiedRelative}</time>
        ) : (
          <time dateTime={lastModifiedAt}>unknown time</time>
        )}
      </p>
    </section>
  );
}
